import { render, staticRenderFns } from "./VeJwXkjhList.vue?vue&type=template&id=17af4a9d"
import script from "./VeJwXkjhList.vue?vue&type=script&lang=js"
export * from "./VeJwXkjhList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports